import { ActiveRecord } from '@mysidewalk/active-record';
import SessionManagerRecordSource from '../lib/SessionManagerRecordSource.js';
import RoleUser from './RoleUser.js';
/**
 */
class RedeemInvite extends ActiveRecord {
    static async redeem(code, params, opts) {
        const Source = this.$source;
        const results = await Source.redeem({ code }, params, opts);
        return results.map((props) => new RoleUser(props));
    }
}
// Custom source to handle POST returning multiple records
class RedeemSource extends SessionManagerRecordSource {
    async redeem(props, params, opts) {
        const result = await this.handleRequest(this.urlFor({ params }), {
            method: 'POST',
            body: this.transformRequestBody(props),
        }, opts);
        return result.records;
    }
}
RedeemInvite.$AR = {
    url: '',
    SourceClass: RedeemSource,
    options: {
        responseRecordsPropertyName: 'roleUsers',
    },
};
export default RedeemInvite;
